import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Fetch taxonomy data from Firestore
 * @returns {Promise<Object>} Taxonomy data with categories and their values
 */
export async function getTaxonomyData() {
  try {
    const taxonomyCollection = collection(db, 'taxonomy');
    const snapshot = await getDocs(taxonomyCollection);
    
    const taxonomyData = {};
    
    snapshot.docs.forEach(doc => {
      const data = doc.data();
      taxonomyData[doc.id] = {
        id: doc.id,
        name: data.name,
        description: data.description,
        required: data.required || false,
        singleValue: data.singleValue || true,
        defaultValue: data.defaultValue,
        values: data.values || []
      };
    });
    
    return taxonomyData;
  } catch (error) {
    console.error('Error fetching taxonomy data:', error);
    throw error;
  }
}

/**
 * Get specific taxonomy category values
 * @param {string} categoryId - The taxonomy category ID (e.g., 'listingType', 'itemCategory')
 * @returns {Promise<Array>} Array of category values with display and value properties
 */
export async function getTaxonomyCategory(categoryId) {
  try {
    const docRef = doc(db, 'taxonomy', categoryId);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      const data = docSnap.data();
      return data.values || [];
    } else {
      console.warn(`Taxonomy category ${categoryId} not found`);
      return [];
    }
  } catch (error) {
    console.error(`Error fetching taxonomy category ${categoryId}:`, error);
    return [];
  }
}

/**
 * Get all taxonomy categories as a flat list for dropdowns
 * @returns {Promise<Object>} Object with category arrays for each taxonomy type
 */
export async function getTaxonomyForFilters() {
  try {
    const taxonomyData = await getTaxonomyData();
    
    return {
      listingType: taxonomyData.listingType?.values || [],
      itemCategory: taxonomyData.itemCategory?.values || [],
      cuisine: taxonomyData.cuisine?.values || [],
      courseType: taxonomyData.courseType?.values || [],
      dishType: taxonomyData.dishType?.values || [],
      dietaryTags: taxonomyData.dietaryTags?.values || []
    };
  } catch (error) {
    console.error('Error fetching taxonomy for filters:', error);
    return {
      listingType: [],
      itemCategory: [],
      cuisine: [],
      courseType: [],
      dishType: [],
      dietaryTags: []
    };
  }
}
